import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { PlaceDto } from '../types/dtos';
import { APP_ENDPOINTS } from 'app/endpoints';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<PlaceDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.PLACE}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'places-with-join', id: 'GET-JOIN' },
            { type: 'places', id: 'GET' },
            { type: 'products-with-join', id: 'GET-JOIN' },
            { type: 'place', id: 'GET-ID' },
        ],
    });
